/**
 * Push an event object to the GTM dataLayer.
 * Initializes `window.dataLayer` if it doesn't exist yet.
 */
export function pushToDataLayer(event: Record<string, unknown>): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}
